export enum LinkAccountErrors {
  EMPTY = 'Empty',
  GENERIC_ACCOUNT_LINK_ERROR = 'Unable to link accounts',
  INVALID_EMAIL = 'Invalid email',
  SAME_ACCOUNT = "You're already using this email with your current account. Enter a different email to link another account.",
}
